import { render, staticRenderFns } from "./moduleList.vue?vue&type=template&id=28f6b8b8&"
import script from "./moduleList.vue?vue&type=script&lang=ts&"
export * from "./moduleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports